import {
  Header,
  HeaderBreadcrumbs,
  HeaderTitle
} from '@jana-technology/platform-ui'
import {
  Addchart,
  AutoAwesomeMosaicOutlined,
  Public
} from '@mui/icons-material'

import { IColorByValueConfig } from 'app/services/api/colorByValue'
import FullWidthLayoutContainer from 'common/components/FullWidthLayoutContainer'
import Toolbar from 'common/components/Toolbar'
import { getParentPathname } from 'common/utils/navigation/pathUtils'

import ColorByValue from 'features/DataManagement/Components/ColorByValue'
import DataViewBreadcrumb from 'features/DataManagement/Components/DataViewBreadcrumb'
import { IDataViewProps } from 'features/DataManagement/DataView'
import {
  RightSideViewAvailability,
  RightSideViewSelection
} from 'features/DataManagement/DataView/Details'

interface IDataViewDetailsPageHeader extends IDataViewProps {
  viewName: string
  colorByValueConfig: IColorByValueConfig | undefined
  showColorByValue: boolean
  availableSideViews: RightSideViewAvailability
  selectedSideView: RightSideViewSelection
  setColorByValueConfig: React.Dispatch<
    React.SetStateAction<IColorByValueConfig | undefined>
  >
  setSelectedView: React.Dispatch<React.SetStateAction<RightSideViewSelection>>
}

const DataViewDetailsPageHeader = ({
  dvBasePath,
  viewName,
  colorByValueConfig,
  showColorByValue,
  availableSideViews,
  selectedSideView,
  setColorByValueConfig,
  setSelectedView
}: IDataViewDetailsPageHeader) => {
  const dmBasePath = getParentPathname(dvBasePath)

  const subheading = (
    <DataViewBreadcrumb
      dataManagementPath={dmBasePath}
      dataViewPath={dvBasePath}
      viewName={viewName}
    />
  )

  const showSideviewToggle = availableSideViews !== 'none'
  const showSideChart = availableSideViews === 'all'

  return (
    <div className='flex flex-col'>
      <Header>
        <FullWidthLayoutContainer>
          <HeaderBreadcrumbs className='ml-0'>{subheading}</HeaderBreadcrumbs>
          <HeaderTitle>{viewName}</HeaderTitle>
        </FullWidthLayoutContainer>
      </Header>
      <Toolbar className='h-10 text-gray-700'>
        {showColorByValue && (
          <ColorByValue
            config={colorByValueConfig}
            setConfig={setColorByValueConfig}
          />
        )}
        <div className='flex flex-1' />
        {showSideviewToggle && (
          <div>
            {showSideChart && (
              <>
                <button
                  type='button'
                  className={[
                    'rounded-sm py-1 pl-2 pr-3 font-medium leading-none text-gray-700',
                    selectedSideView === 'split'
                      ? 'bg-gray-100 text-blue-lighthouse-500'
                      : ''
                  ].join(' ')}
                  onClick={() => {
                    selectedSideView === 'split'
                      ? setSelectedView('none')
                      : setSelectedView('split')
                  }}
                >
                  <AutoAwesomeMosaicOutlined className='mr-1' />
                  Split
                </button>
                <button
                  type='button'
                  className={[
                    'rounded-sm py-1 pl-2 pr-3 font-medium leading-none text-gray-700',
                    selectedSideView === 'charts'
                      ? 'bg-gray-100 text-blue-lighthouse-500'
                      : ''
                  ].join(' ')}
                  onClick={() => {
                    selectedSideView === 'charts'
                      ? setSelectedView('none')
                      : setSelectedView('charts')
                  }}
                >
                  <Addchart className='mr-1' />
                  Charts
                </button>
              </>
            )}
            <button
              type='button'
              className={[
                'rounded-sm py-1 pl-2 pr-3 font-medium leading-none text-gray-700',
                selectedSideView === 'map'
                  ? 'bg-gray-100 text-blue-lighthouse-500'
                  : ''
              ].join(' ')}
              onClick={() => {
                selectedSideView === 'map'
                  ? setSelectedView('none')
                  : setSelectedView('map')
              }}
            >
              <Public className='mr-1' />
              Map
            </button>
          </div>
        )}
      </Toolbar>
    </div>
  )
}

export default DataViewDetailsPageHeader
